// import COMPANY_API from '@/api/masterData/company.js';

export const formFields = (ctx) => {
  return [
    // {
    //   prop: 'statementCompanyNo',
    //   name: '公司名称',
    //   type: 'ajaxSelect',
    //   apiUrl: COMPANY_API.GET_COMPANY_LIST_API,
    //   apiData: {
    //     adminFlag: ctx.userInfo.adminFlag,
    //     tenantCode: ctx.userInfo.tenantCode,
    //   },
    //   clearable: true,
    //   filterable: true,
    //   valueKey: 'companyCode',
    //   labelKey: 'companyName',
    //   changeMethod: 'changeCompanyHandler',
    //   valueType: 'object',
    //   method: 'post',
    // },
    // {
    //   prop: 'statementDepartmentNo',
    //   name: '部门',
    //   type: 'ajaxSelect',
    //   apiUrl: COMPANY_API.GET_DEPARTMENT_LIST_API,
    //   apiData: {
    //     belongCompanyCode: ctx.baseFormData.statementCompanyNo,
    //     tenantCode: ctx.userInfo.tenantCode,
    //   },
    //   clearable: true,
    //   filterable: true,
    //   disabled: ctx.baseFormData.statementCompanyNo == '',
    //   valueKey: 'createDepartmentCode',
    //   labelKey: 'departmentName',
    //   changeMethod: 'changeDepartmentHandler',
    //   method: 'post',
    //   valueType: 'object',
    // },
    // {
    //   name: '客户名称',
    //   prop: 'customerName',
    //   type: 'searchTableSpec',
    //   searchType: 'sapCustomer',
    //   isMultiple: true,
    //   changeMethod: ctx.changeCustomsMethod,
    // },
    // {
    //   name: '合同编号',
    //   prop: 'contractNo',
    //   type: 'input',
    // },
    {
      prop: 'businessCompanyNo',
      name: '公司名称',
      type: 'select',
      options: ctx.companyList,
      value: 'personCompanyCode',
      label: 'personCompanyName',
      changeMethod: ctx.changeCompanyHandler,
      disabled: true,
    },
    {
      prop: 'businessDepartmentCode',
      name: '部门',
      type: 'select',
      // disabled: ctx.query?.businessCompanyNo == '',
      disabled: true,
      options: ctx.departmentList,
      value: 'personDepartmentCode',
      label: 'personDepartmentName',
      changeMethod: ctx.changeDepartmentHandler,
    },
    {
      name: '合同编号',
      prop: 'contractNo',
      type: 'searchTableSpec',
      searchType: 'parkWarehouseContract',
      extraData: {
        parkCompanyCode: ctx.query.businessCompanyNo,
        businessDepartmentCode: ctx.query.businessDepartmentCode,
      },
      disabled: true,
      isMultiple: true,
      changeMethod: ctx.changeContractMethod,
      currentValue: ctx.query?.contractNo,
    },
    // {
    //   name: '客户名称',
    //   prop: 'customerNo',
    //   type: 'searchTableSpec',
    //   searchType: 'partner',
    //   extraData: {
    //     companyCode: ctx.query.businessCompanyNo,
    //     departmentCode: ctx.query.businessDepartmentCode,
    //     partnerTypes: 'HZHB01,HZHB03,HZHB11,HZHB10',
    //   },
    //   isMultiple: true,
    //   changeMethod: ctx.changeSupplyChainMethod,
    // },
    // {
    //   name: '订单编号',
    //   prop: 'orderCode',
    //   type: 'input',
    // },
    // {
    //   name: '指令单编号',
    //   prop: 'instructionNo',
    //   type: 'input',
    // },

    {
      name: '业务类别',
      prop: 'businessCategory',
      type: 'select',
      disabled: true,
      options: ctx.dictListMap?.businessCategory || [],
    },

    {
      name: '状态',
      prop: 'processStatus',
      type: 'select',
      disabled: true,
      options: [
        {
          label: '未处理',
          value: '0',
        },
        {
          label: '已处理',
          value: '1',
        },
      ],
    },
    {
      prop: 'expenseType',
      name: '费用类型',
      type: 'select',
      options:
        [
          ...ctx.dictListMap?.warehouseExpenseName,
          ...ctx.dictListMap?.warehouseContractGuilinExpenseList,
          ...ctx.dictListMap?.warehouseContractGuizhongLoadExpenseList,
          ...ctx.dictListMap?.warehouseContractLoadExpenseList,
        ] || [],
      disabled: true,
    },
    // {
    //   name: '费用编号',
    //   prop: 'expenseNo',
    //   type: 'input',
    // },
    {
      prop: 'createMethod',
      name: '创建方式',
      type: 'select',
      options: ctx.dictListMap?.createMethod || [],
    },
    {
      name: '应收账期',
      prop: 'accountPeriod',
      type: 'date',
      format: 'yyyy-MM',
    },

    {
      name: '结算单编号',
      prop: 'settlementNoLike',
      type: 'input',
    },
    {
      // 申请日期从
      name: '业务结算日期从',
      prop: 'periodDateStart',
      type: 'startDaterangePicker',
    },
    {
      // 申请日期到
      name: '业务结算日期至',
      prop: 'periodDateEnd',
      type: 'endDaterangePicker',
    },
    {
      name: '费用生成日期从',
      prop: 'expenseGenerationDateStart',
      type: 'startDaterangePicker',
    },
    {
      name: '费用生成日期至',
      prop: 'expenseGenerationDateEnd',
      type: 'endDaterangePicker',
    },
    {
      name: '原币结算金额(含税)',
      prop: ['originalAmountStart', 'originalAmountEnd'],
      type: 'inputRange',
      precision: 2, //精度，就是保留几位小数,默认两位
      max: 99999999999999.99,
    },
  ];
};

export const tableColumnList = [
  // {
  //   type: 'checkbox',
  //   visible: true,
  //   width: '50',
  //   fixed: 'left',
  // },
  // {
  //   type: 'seq',
  //   title: 'table.index',
  //   visible: true,
  //   width: '80',
  // },

  {
    field: 'expenseNo',
    title: '费用编号',
    visible: true,
  },
  {
    field: 'businessCompanyName',
    title: '公司名称',
    visible: true,
  },
  {
    field: 'businessDepartmentName',
    title: '部门名称',
    visible: true,
  },
  {
    field: 'customerName',
    title: '客户名称',
    visible: true,
    width: '150',
  },
  {
    field: 'contractNo',
    title: '合同编号',
    visible: true,
  },
  {
    field: 'expenseGenerationDate',
    title: '费用生成日期',
    width: '160',
  },

  // {
  //   field: 'orderCode',
  //   title: '订单编号',
  //   width: '160',
  // },
  // {
  //   field: 'productTypeName',
  //   title: '产品',
  //   visible: true,
  //   width: '150',
  // },
  // {
  //   field: 'serviceTypeName',
  //   title: '服务',
  //   visible: true,
  //   width: '150',
  // },
  {
    field: 'accountPeriod',
    title: '应收账期',
    visible: true,
    width: '150',
  },
  {
    field: 'expenseTypeName',
    title: '费用类型',
    visible: true,
  },

  {
    field: 'originalPrice',
    title: '原币结算单价(含税)',
    visible: true,
  },
  {
    field: 'statementQuantity',
    title: '结算数量',
    visible: true,
  },
  {
    field: 'unitName',
    title: '计量单位',
    visible: true,
  },
  {
    field: 'originalAmount',
    title: '原币结算金额(含税)',
    visible: true,
  },
  {
    field: 'currencyName',
    title: '币种',
    visible: true,
  },
  {
    field: 'exchangeRate',
    title: '汇率',
    visible: true,
  },
  {
    field: 'domesticAmount',
    title: '本币结算金额(含税)',
    visible: true,
  },
  // {
  //   field: 'multiBillingRuleFlag',
  //   title: '是否有多个计费规则',
  //   visible: true,
  // },
  // {
  //   field: 'exceptionCode',
  //   title: '异常编号',
  //   visible: true,
  // },
  // {
  //   field: 'confirmStatus',
  //   title: '确认状态',
  //   visible: true,
  // },
  {
    field: 'processStatus',
    title: '状态',
    visible: true,
  },
  {
    field: 'businessName',
    title: '业务（作业）名称',
    visible: true,
  },
  {
    field: 'businessDocCode',
    title: '业务单据编码',
    visible: true,
  },
  {
    field: 'settlementNo',
    title: '结算单编号',
    visible: true,
  },
  {
    field: 'periodDateFrom',
    title: '业务结算日期从',
    visible: true,
  },
  {
    field: 'periodDateUntil',
    title: '业务结算日期至',
    visible: true,
  },
  {
    field: 'productName',
    title: '商品名称',
    visible: true,
  },
  {
    field: 'goodsCategoryName',
    title: '商品类别',
    visible: true,
  },
  {
    field: 'productModel',
    title: '规格',
    visible: true,
  },
  // {
  //   field: 'abnormalExpenseFlag',
  //   title: '是否是异常费用',
  //   visible: true,
  // },

  {
    field: 'createMethod',
    title: '创建方式',
    visible: true,
  },
];
